app.controller("EditSysparamController", ["$scope", "$filter", "$uibModalInstance", "SysParam", "sysparam",
    function ($scope, $filter, $uibModalInstance, SysParam, sysparam) {
        $scope.format = "dd-MM-yyyy";
        $scope.popup1 = {
            opened: false
        };

        $scope.types = [{
            _id: 'String',
            name: 'ტექსტი'
        }, {
            _id: 'Number',
            name: 'რიცხვი'
        }, {
            _id: 'Date',
            name: 'თარიღი'
        }];

        $scope.type = $scope.types.filter(function(tp) {
            return tp._id === sysparam.type
        })[0];
        $scope.name = sysparam.name;
        $scope.key = sysparam._id;
        $scope.description = sysparam.description;
        $scope.value = sysparam.value;

        $scope.open1 = function () {
            $scope.popup1.opened = true;
        };

        $scope.update = function () {
            SysParam.updateSysParam({
                key: $scope.key,
                name: $scope.name,
                description: $scope.description,
                value: $scope.value,
                type: $scope.type._id
            }).then(function (created) {
                if (created) {
                    $uibModalInstance.close();
                }
            })
        };
        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);